import { ProfileOutlined, SettingOutlined } from "@ant-design/icons";
import * as React from "react";
import { BlankLink } from "src/components/BlankLink/BlankLink";
import { MultipleItemInfo } from "src/components/columns/MultipleItemInfo";
import { makeMdmActionColumn, RenderLinkAction } from "src/components/MdmTable";
import { RtColumn } from "src/components/ReactiveTable/RtColumn";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

import { columnDisplayId, sysColumnsHistory } from "../sysData/sysColumns";
import { ZCatalog } from "./ZCatalog";

type Params = {
  showScheme: boolean;
  settings?: boolean;
  records?: boolean;
};

export const catalogBaseColumns: RtColumn<ZCatalog>[] = [
  columnDisplayId,
  {
    key: "name",
    title: "Название",
    render: ({ name }) => name,
    minWidth: 200,
    width: "10%",
  },
  {
    key: "description",
    title: "Описание",
    render: ({ description }) => description,
    minWidth: 200,
  },
];

export const catalogColumns = (params: Params): RtColumn<ZCatalog>[] => [
  ...catalogBaseColumns,
  ...(params.showScheme
    ? [
        {
          key: "schema",
          title: "Первичная спецификация",
          render: ({ schema }) => (
            <BlankLink
              href={makeUrl(PageUrl.managementPrimSpecCard, { id: schema.id })}
              title="Открыть карточку спецификации в новой вкладке"
            >
              {schema.label}
            </BlankLink>
          ),
          width: "10%",
          minWidth: 100,
        } satisfies RtColumn<ZCatalog>,
      ]
    : []),
  {
    key: "classifiers",
    title: "Классификаторы",
    render: ({ classifiers }) => (
      <MultipleItemInfo list={classifiers} getInfo={(it) => it} />
    ),
    width: "20%",
    minWidth: 200,
  },
  ...sysColumnsHistory,
  ...(params.settings
    ? [
        makeMdmActionColumn<ZCatalog>({
          key: "settings",
          render: ({ id }) => (
            <RenderLinkAction
              icon={<SettingOutlined />}
              tooltip="Открыть настройки в новой вкладке"
              href={makeUrl(PageUrl.managementCatalogEdit, { id })}
            />
          ),
        }),
      ]
    : []),
  ...(params.records
    ? [
        makeMdmActionColumn<ZCatalog>({
          key: "records",
          render: ({ id }) => (
            <RenderLinkAction
              icon={<ProfileOutlined />}
              tooltip="Открыть список в новой вкладке"
              href={makeUrl(PageUrl.records, { id })}
            />
          ),
        }),
      ]
    : []),
];
